<template>
  <div>
    <div class="operation">
      <el-tabs v-model="activeName" @tab-click="handleClick" class="tabName">
        <el-tab-pane label="上传文档" name="a"></el-tab-pane>
        <el-tab-pane label="粘贴文档" name="b"></el-tab-pane>
      </el-tabs>
      <div class="batch-top" v-if="activeName == 'a'">
        <el-upload class="upload-demo" drag :action="action" :file-list="fileList" :headers="headers" :limit="2" :on-change="onChange" :on-success="success" :before-upload="beforeUpload">
          <img src="~@/assets/newicons/ib03.png" alt="">
          <div class="div-text fl">
            <div class="el-upload__text">点击或将文件拖拽至此处<span class="file-name" @click.stop="clickDownload">下载模板.xls</span></div>
            <div class="el-upload__tip" slot="tip">1. 下载模版并填充企业全称信息； 2. 上传文件不超过2M，仅支持Excel（xls、xlsx）文件； 3. 单次查询企业数量不能超过200家。</div>
          </div>
        </el-upload>

        <div class="hint-file" v-if="fileList.length > 0">
          <div class="ll"> 
            <img src="@/assets/newicons/sn01.png" alt="">
            <span style="font-size: 14px;font-weight: 400;color: #999999;line-height: 20px;">{{fileList[0]['name']}} </span>  
          </div>
          <div class="rr"> <img style="width:20px;" src="@/assets/newicons/sn02.png" alt=""> </div>
        </div>
      </div>
      <div class="post-txt" v-if="activeName == 'b'">
          <el-input
              type="textarea"
              :rows="5"
              :placeholder="'例如：'+'\n'+'珍岛信息技术(上海)股份有限公司'+'\n'+'珍岛信息技术(上海)股份有限公司'+'\n'+'珍岛信息技术(上海)股份有限公司'"
              maxlength="3000"
              show-word-limit
              v-model="postTxt">
            </el-input>
            <el-button type="dialog-confirm" style="margin-top:20px;float:right" @click="matchCompany" :disabled="loading">匹配</el-button>
      </div>
    </div>
    <div class="div-list" v-loading="loading">
      <company-card-list :companyType="8" class="ccl" :searchType="activeTab" :batchActions="batchActions" ref="cardlist" :list="list" @handle-page-num="handlePageNum"  @handle-page="handlePage">
        <div class="searchBar">
          <span class="font-15-md">小T为您找到 <span class="blueColor" style="color: #5088FF;">{{_totalElements}}</span> 家企业资源</span>
        </div>
      </company-card-list>
    </div>
    <Robot />
    <right-float ref="rightFloat" :globalRfType="true"></right-float>
  </div>
</template>

<script>
import CompanyCardList from '@/views/clue/components/companyCardList'
import { getToken, getCookie } from '@/base/cookie'
import Robot from '@/views/clue/components/robot'
import {batchSearchByText} from '../api/index'
import RightFloat from '@/components/rightFloatBtn'
export default {
  name: 'batchSearch',
  provide() {
    return {
      unlockSourceType: 8
    }
  },
  components: {
    CompanyCardList, Robot,RightFloat
  },
  data () {
    return {
      activeName:'a',
      postTxt:'',
      fileList: [],
      headers: {
        'X-Token': getToken(),
        'ERP-Token': getCookie('ERP-Token')
      },
      // action: process.env.VUE_APP_BASE_API_AI + 'company/batchSearchByExcel',
      action: process.env.VUE_APP_BASE_API_AI + 'vv5/company/batchSearchByExcel', //HID
      maxFileSize: 2048, // 2MB
      allowType: ['.xls', '.xlsx'],
      activeTab: 0,
      allTotal: 0,
      loading: false,
      listArray: [
      ],
      list: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        tab: 1,
        tableData: []
      }
    }
  },
  computed: {
    batchActions () {
      return this.surplus < 1 ? [false, true, false] : [true, true, false]
    },
    _totalElements () {
      if (this.allTotal < 100) return this.allTotal
      if (this.allTotal < 200000) return `${this.allTotal.toString().split('').reduce((res, v) => res ? res + 0 : v, '')}+`
      return '200000+'
    },
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    // 数据重置
    handleClick(tab, event) {
        console.log(tab, event);
        this.list.tableData = []
        this.allTotal = 0
        this.fileList = []
        this.postTxt = ''
        this.list.pageSize = 10
        this.list.pageNum = 1
    },
    // 粘贴文档
    matchCompany(){
      if(this.postTxt.trim() == ''){
          this.$message.warning('请粘贴内容')
          return
      }
        let postTxtArr = this.postTxt.split("\n")
        let postTxtArrSort = []
        postTxtArr.forEach(v => {
            if(v){
              postTxtArrSort.push(v)
            }
        });
        this.loading = true
        batchSearchByText({companyNames:postTxtArrSort}).then(res =>{
          this.loading = false
            if (res.code == 200) {
                this.listArray = res.data
                this.allTotal = res.data.length
                this.list.total = res.data.length > 15000 ? 15000 : res.data.length
                const start = (this.list.pageNum - 1) * this.list.pageSize
                const end = Math.min(this.list.pageNum * this.list.pageSize, this.listArray.length)
                this.list.tableData = this.listArray.slice(start, end)
              } else {
                this.listArray = []
                this.allTotal = 0
                this.list.total = 0
                this.list.tableData = []
                this.$message.error(res.message)
              }
        })
    },
    onChange (file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
    },
    beforeUpload (file) {
      if (this.maxFileSize && file.size > this.maxFileSize * 1024) {
        this.$message({
          type: 'error',
          message: '文件大小超标'
        })
        return false
      }
      if (this.allowType) {
        var index = this.allowType.indexOf(file.name.substring(file.name.lastIndexOf('.')).toLowerCase())
        if (index < 0) {
          this.$message({
            type: 'error',
            message: '只支持' + this.allowType.join('、') + '格式文件!'
          })
          return false
        }
      }
      this.loading = true
    },
    success (res, file, fileList) {
  
      this.loading = false
      if (res.code == 200) {
        this.fileList = fileList
        this.listArray = res.data
        this.allTotal = res.data.length
        this.list.total = res.data.length > 15000 ? 15000 : res.data.length
        const start = (this.list.pageNum - 1) * this.list.pageSize
        const end = Math.min(this.list.pageNum * this.list.pageSize, this.listArray.length)
        this.list.tableData = this.listArray.slice(start, end)
      } else {
        this.fileList = []
        this.listArray = []
        this.allTotal = 0
        this.list.total = 0
        this.list.tableData = []
        this.$message.error(res.message)
      }
    },
    handlePage (val) {
      if (this.list.pageNum !== val) {
        this.list.pageNum = val
        const start = (this.list.pageNum - 1) * this.list.pageSize
        const end = Math.min(this.list.pageNum * this.list.pageSize, this.listArray.length)
        this.list.tableData = this.listArray.slice(start, end)
      }
    },
    handlePageNum(val){
          this.list.pageNum = 1
          this.list.pageSize = val
          const start = (this.list.pageNum - 1) * this.list.pageSize
          const end = Math.min(this.list.pageNum * this.list.pageSize, this.listArray.length)
          this.list.tableData = this.listArray.slice(start, end)
    },
    clickDownload () {
      // window.open('/Template.xls')
      // window.open(`/模板.xls?t=${+new Date()}`)
      this.Global.downloadFile(`/模板.xls?t=${+new Date()}`,'模板.xls')
    }
  },
  destroyed () {
  }
}
</script>

<style scoped lang="scss">
.font-15-md{
  font-size: 15px;
  font-weight: 600;
  color: rgba(52,57,81,0.7);
}
.operation{
  background: #ffff;
  box-shadow: 0px 1px 5px 0px rgba(38, 38, 38, 0.1);
  border-radius: 4px;
 
}
.tabName{
    padding: 8px 24px 0;
  box-sizing: border-box;
  background: #ffff;
}
::v-deep{
    .post-txt{
      padding: 9px 24px 73px;
      box-sizing: border-box;
      .el-textarea__inner{
        background: #FCFCFC;
        padding-top: 16px;
        height: 132px;
         &:-ms-input-placeholder {
            color: #5C6075;
            font-size: 14px;
            line-height: 20px;
          }
          &::-webkit-input-placeholder {
            color: #5C6075;
             font-size: 14px;
             line-height: 20px;
          }
          &::-moz-placeholder {
            color: #5C6075;
             font-size: 14px;
             line-height: 20px;
          }
      }
      .el-input__count{
        background: none;
        right: 10px;
        bottom: 10px;
      }
      .el-button--dialog-confirm{
        padding-top: 0;
        padding-bottom: 0;
        height: 32px;
      }
       
    }
}

/deep/ .el-upload-list__item-name{
  i{
    width: auto;
  }
}
.div-list {
  margin-top: 16px;
  width: 100%;
  border-radius: 4px;
  padding-bottom: 24px;
  overflow: hidden;
  /deep/ .cardTitle {
    // padding: 0 120px;
    .insideBox{
      padding-left: 33px;
    }
  }
  /deep/ .clueList {
    // width: calc(100% - 240px);
    margin: 0 auto;
  }
}
.div-title {
  height: 50px;
  line-height: 50px;
  padding-left: 140px;
  span {
    i {
      color: #d9001b;
    }
  }
}
.batch-top {
  width: 100%;
  padding:9px 24px 24px;
  box-sizing: border-box;
  .upload-demo{

  }
  /deep/.el-upload {
    width: 100%;
  }
  /deep/.el-upload-dragger {
    // background: #fafafa;
    background: #F8F8F8;
    border-radius: 4px;
    border: 1px dashed #D9D9D9;
    width: 100%;
    padding-top: 25px;
    padding-left: 152px;
    height: 82px;
    img {
      float: left;
      width: 30px;
      height: 30px;
      font-size: 30px;
      // margin-left: 100px;
      // margin-top: 50px;
    }
    .div-text {
      // width: 65%;
      display: inline-block;
      margin-left: 16px;
      margin-top: -3px;
      // margin-top: 70px;
      // margin-left: 30px;
      .el-upload__text {
        text-align: left;
        color: rgba(51, 51, 51, 1);
        line-height: 18px;
        font-size: 13px;
        .file-name {
          color: #5088FF;
          font-size: 13px;
          margin-left: 7px;
        }
      }
      .el-upload__tip {
        // color: #ffa72e;
        margin-top: 8px;
        margin-left: 0;
        color: rgba(51, 51, 51, 0.5);
        line-height: 17px;
        font-size: 12px;
        text-align: left;
        // word-wrap: break-word;
        // word-break: break-all;
      }
    }
  }
}
.span01{
  font-size: 16px;
  font-weight: 600;
  color: rgba(52, 57, 81, 0.7);
  line-height: 22px;
}
.batch-top{
  /deep/ .el-upload-list {
    display: none;
  }
}
.hint-file{
  padding-top: 13px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .ll{
    img{
      width: 20px;
      height: 20px;
      background: red;
      margin-right: 4px;
    }
    .rr{
      img{
        width: 16px;
        height: 16px;
      }
    }
  }
}
// /deep/ {
//   .el-upload-list__item-name{
//     color: rgba(153, 153, 153, 1);
//   }
// }
</style>
